let modal__overlay = document.querySelector('.modal__overlay'); 
let geoip_modal = modal__overlay.querySelector('.geoip-modal__content');
let geoip_region_picker_select = geoip_modal.querySelector('.region-picker__toggle');
let geoip_region_picker_list = geoip_modal.querySelector('.region-picker__list');
let geoip_country = geoip_modal.querySelectorAll('.geoip-country');
let geoip_shop_links = geoip_modal.querySelectorAll('.geoip-shop-link');
let geoip_host = geoip_modal.querySelector('.geoip-host');
let geoip_cta = geoip_modal.querySelector('.geoip-modal__cta');
let geoip_cta_dismiss = geoip_modal.querySelector('a.geoip-modal__cta-dismiss');

let language_switcher = modal__overlay.querySelector('.language-switcher__content');
let language_region_picker_select = language_switcher.querySelector('.region-picker__toggle');
let language_region_picker_list = language_switcher.querySelector('.region-picker__list');
let language_cta = language_switcher.querySelector('.language-switcher__cta');

let header_lang_btn = document.getElementById("header-lang");
let header_lang_btn_mobile = document.getElementById("header-lang-mobile");

const SHIP_FROM_UK = ["GG", "IM", "JE", "GB", "US"]
const SHIP_FROM_EU = ["IE", "RU", "AL", "AD", "BY", "BA", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "GE", "GI", "GR", "HU", "IS", "IT", "XK", "LV", "LI", "LT", "LU", "MT", "MD", "MC", "ME", "NL", "MK", "NO", "PL", "PT", "RO", "RU", "SM", "RS", "SK", "SI", "ES", "SJ", "SE", "TR", "UA", "VA"]
const SHIP_FROM_DE = ["DE", "AT", "CH"]
const SHIP_FROM_FR = ["FR"]
const SHIP_FROM_NL = ["NL", "BE"]

const shops = {
  de: { name: "DE", host: "greenforce.com", country: "DE / CH" },
  at: { name: "AT", host: "greenforce.com", country: "Austria" },
  uk: { name: "UK", host: "uk.greenforce.com", country: "United Kingdom" },
  eu: { name: "EU", host: "eu.greenforce.com" , country: "Europe"},
  fr: {name: "FR", host: "fr.greenforce.com", country: "France"},
  nl: {name: "NL", host: "nl.greenforce.com", country: "The Netherlands" }
}

const GEOIP_APPLY_TO = "AT";

const isDACHShippingCountry = (country_code) => {
  return SHIP_FROM_DE.includes(country_code)
}

const isUKShippingCountry = (country_code) => {
  return SHIP_FROM_UK.includes(country_code)
}

const isEUShippingCountry = (country_code) => {
  return SHIP_FROM_EU.includes(country_code)
}

const isFRShippingCoungry = (country_code) => {
  return SHIP_FROM_FR.includes(country_code)
}

const isNLShippingCoungry = (country_code) => {
  return SHIP_FROM_NL.includes(country_code)
}

const deactivateGeoRedirect = () => {
  localStorage.setItem("deactivateGeoRedirect", String(true))
}

const determineProposedShop = (country_code) => {
  console.log("GeoIP - detected country: ", country_code)
  if (country_code == GEOIP_APPLY_TO) return shops.at
  if (isDACHShippingCountry()) return shops.de
  if (document.querySelector('#switch-uk') && isUKShippingCountry(country_code)) return shops.uk
  if (document.querySelector('#switch-eu') && isEUShippingCountry(country_code)) return shops.eu
  if (document.querySelector('#switch-nl') && isNLShippingCoungry(country_code)) return shops.nl
  if (document.querySelector('#switch-fr') && isFRShippingCoungry(country_code)) return shops.fr
  return shops.de
}

document.addEventListener('DOMContentLoaded', (event) => {
  fetch("https://get.geojs.io/v1/ip/geo.json", { mode: 'cors' })
  .then(response => response.json())
  .then(function(data) {
    if (data == null) {
      console.log("GeoIP: Could not fetch geoip data");
      return
    }
    const { continent_code, country_code, country } = data;
    const proposedShop = determineProposedShop(country_code);

    var current_host = window.location.hostname.replace("www.", "");
    var current_store_key = Object.keys(shops).find(key => shops[key]['host'] === current_host);

    var current_store = shops[current_store_key];
    if(!current_store) {
      // dummy for localhost
      current_store = {
        name: "localhost"
      };
    }

    header_lang_btn.innerHTML = current_store.name;
    header_lang_btn_mobile.innerHTML = current_store.name;
    language_region_picker_select.dataset.switchValue = current_store.name;
    language_region_picker_select.querySelector('.store_name').innerHTML = current_store.country
    if(language_region_picker_list.querySelector("#switch-" + current_store.name.toLowerCase())) {
      language_region_picker_list.querySelector("#switch-" + current_store.name.toLowerCase()).classList.add('d-none');
    }

    geoip_country.forEach(c=>{
      c.innerHTML = country;
    })

    geoip_shop_links.forEach(link => {
      link.innerHTML = proposedShop.host;

      // AT Fix
      if(proposedShop.name == "AT"
        && document.getElementById("switch-at")
      ) {
        link.innerHTML += " / AT";
        link.setAttribute("onClick", document.getElementById("switch-at").getAttribute("onClick"));
        link.addEventListener("click", function() {
          localStorage.setItem("deactivateGeoRedirect", true);
        });
      }
    });

    if(current_store === undefined || current_store === 'undefined') return;

    if(current_store.host) {
      geoip_host.innerHTML = current_store.host;
    }
    else {
      geoip_host.innerHTML = "greenforce.com";
    }

    // update link and append forcestay=true param
    // This should be used "later" also for "store switcher dropdown", and always save the state in localStorage, otherwise prompt
    // always appears again

    // ToDo: write general function to read param forcestay=true and save this to localStorage,
    // if this is true then also hide the GEO Popup by default
    // below is just example...

    geoip_cta.addEventListener('click', function(event){
      event.preventDefault()
      window.location.href = `https://${proposedShop?.host}?forcestay=true`;
    })

    geoip_cta_dismiss.addEventListener('click', function(event){
      event.preventDefault();
      deactivateGeoRedirect();
      close_modal();
    })

    var selected_option = geoip_region_picker_list.querySelector(".flag-" + current_store.name.toLowerCase());
    if(selected_option) {
      selected_option.classList.add('d-none');
      geoip_region_picker_select.querySelector('img').src = selected_option.querySelector('img').src;
      geoip_region_picker_select.querySelector('.store_name').innerHTML = selected_option.querySelector('.store_name').innerHTML;
    }

    if(current_store != proposedShop
      && !window.localStorage.deactivateGeoRedirect
    ) {
      if(proposedShop.name == "AT" && window.location.pathname != "/") return; // activate AT popup only on Home page

      modal__overlay.classList.add('modal__overlay__is-open');
      geoip_modal.classList.remove('d-none')
    } else {
      deactivateGeoRedirect();
    }

  });
})

header_lang_btn.addEventListener("click", function(e) {
  modal__overlay.classList.add("modal__overlay__is-open");
  language_switcher.classList.remove("d-none");
});

header_lang_btn_mobile.addEventListener("click", function(e) {
  modal__overlay.classList.add("modal__overlay__is-open");
  language_switcher.classList.remove("d-none");
  document.getElementById("menu-mobile-btn").click();
});

geoip_region_picker_select.addEventListener('click', function(e){
  if(geoip_region_picker_list.classList.contains('d-none')){
    geoip_region_picker_list.classList.remove('d-none');
  }else{
    geoip_region_picker_list.classList.add('d-none');
  }
})

language_region_picker_select.addEventListener('click', function(e){
  if(language_region_picker_list.classList.contains('d-none')){
    language_region_picker_list.classList.remove('d-none');
  }else{
    language_region_picker_list.classList.add('d-none');
  }
})

language_region_picker_list.querySelectorAll('.region-picker__list-option').forEach(option=>{
  option.addEventListener('click', function(e) {
    language_region_picker_select.querySelector('.store_name').innerHTML = option.querySelector('.store_name').innerHTML
    language_region_picker_select.dataset.switchValue = option.dataset.switchValue;
    language_region_picker_list.querySelectorAll('.region-picker__list-option').forEach(item=>{
      item.classList.remove('d-none')
    })
    option.classList.add('d-none')
    language_region_picker_list.classList.add('d-none');

  })
})

language_cta.addEventListener('click', function(e){
  selected_store = shops[language_region_picker_select.dataset.switchValue.toLowerCase()];
  if(typeof selected_store === 'undefined') return;
  window.location.href = `https://${selected_store?.host}?forcestay=true`;
})

geoip_region_picker_list.querySelectorAll('.region-picker__list-option').forEach(option=>{
  option.addEventListener('click', function(e) {
    deactivateGeoRedirect();
  })
})

modal__overlay.addEventListener('click', function(e) {
  if(!geoip_modal.classList.contains('d-none')){
    if (geoip_modal.contains(e.target)) {
    } else{
      console.log("geo out")
      deactivateGeoRedirect()
      close_modal();
    }
  }

  if(!language_switcher.classList.contains('d-none')){
    if(language_switcher.contains(e.target)){
        // click inside of language switcher modal
    }else{
      console.log("lnag out")
      close_modal()
    }
  }

});

function close_modal() {
  modal__overlay.classList.remove("modal__overlay__is-open");
  language_switcher.classList.add('d-none');
  geoip_modal.classList.add('d-none');
}
